export default __webpack_public_path__ + "static/imgExcesspng-0a37f6d33307b0c6bdafffa1b362c156.png";